import { BankIcon } from "@/components/BankIcon";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  GREEN_ACTION_BUTTON_DISABLED,
  GREEN_ACTION_BUTTON_ENABLED_WITH_SHADOW,
} from "@/lib/buttonStyles";
import { constructBBAN, renderBankName } from "@/lib/utils";
import { type BankAccount } from "@/model/account";

interface Props {
  bankAccount: BankAccount;
  selectAccount: (account: BankAccount) => void;
  isLoading: boolean;
  className?: string;
}

export default function BankAccount({
  bankAccount,
  selectAccount,
  isLoading,
  className,
}: Props) {
  return (
    <Card className={`w-full gap-0 py-3 ${className ?? ""}`}>
      <CardContent className="flex items-center justify-between gap-2 pl-2 pr-4 w-full text-left">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <div className="shrink-0">
            <BankIcon bankId={bankAccount.bankId} size={30} />
          </div>
          <div className="flex flex-col gap-0.5 min-w-0">
            <span className="text-base font-medium">
              {renderBankName(bankAccount.bankId)}
            </span>
            <span className="text-sm text-muted-foreground tabular-nums tracking-wide">
              {constructBBAN(bankAccount.bban)}
            </span>
          </div>
        </div>
        <Button
          type="button"
          className={
            isLoading
              ? GREEN_ACTION_BUTTON_DISABLED
              : GREEN_ACTION_BUTTON_ENABLED_WITH_SHADOW
          }
          disabled={isLoading}
          onClick={() => selectAccount(bankAccount)}
        >
          Greiða
        </Button>
      </CardContent>
    </Card>
  );
}
